// 広報誌「ホームだより」アーカイブ
// 年1回の発行ごとに各ホームのエントリを追加する（articleId は NewsPage.js の news 配列の id）
// homeId: HomeDetailPage のslug（kanransya/yui/leap/switch/ties）または 'sodachinoki'
export const newsletters = [
  { vol: 22, year: 2026, homeId: 'leap', articleId: 8, thumb: '/newsletters/vol22/leap-thumb.jpg' },
  { vol: 22, year: 2026, homeId: 'ties', articleId: 9, thumb: '/newsletters/vol22/ties-thumb.jpg' },
  { vol: 22, year: 2026, homeId: 'kanransya', articleId: 10, thumb: '/newsletters/vol22/kanransha-thumb.jpg' },
  { vol: 22, year: 2026, homeId: 'switch', articleId: 11, thumb: '/newsletters/vol22/switch-thumb.jpg' },
  { vol: 22, year: 2026, homeId: 'sodachinoki', articleId: 12, thumb: '/newsletters/vol22/sodachinoki-thumb.jpg' },
  { vol: 22, year: 2026, homeId: 'yui', articleId: 13, thumb: '/newsletters/vol22/yui-thumb.jpg' }
];
